var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":_vm.url}},[_c('img',{attrs:{"alt":"","src":"/svg/invoice.svg"}}),_c('p',{staticClass:"mt-1 text-center"},[_vm._v(_vm._s(_vm.text.toLowerCase()))])])])}
var staticRenderFns = []

export { render, staticRenderFns }